import { stringIsNullOrEmpty } from '../../common/util';

const _INITIAL_STATE = {
    isBusy: false,
    message: '',
    beginHeaderTimer: false
};

export const _APP_KEY = {
    BUSY: 'Busy',
    IDLE: 'Idle',
    TIMER: 'Timer'
};

/// <summary>
/// Author: Nelson
/// </summary>
export default (state = _INITIAL_STATE, action) => {
    switch (action.type) {
        case _APP_KEY['BUSY']:
            return {
                ...state,
                isBusy: true,
                message: stringIsNullOrEmpty(action.message) ? _INITIAL_STATE.message : action.message
            }
            break;
        case _APP_KEY['IDLE']:
            return {
                ...state,
                isBusy: false
            }
            break;
        case _APP_KEY['TIMER']:
            return {
                ...state,
                beginHeaderTimer: action.beginHeaderTimer
            }
            break;
        default:
            return state;
            break;
    }
};